<template>
  <div class="row">
    <div class="col-md-4">
      <div class="card">
        <div class="card-body border-primary">
          <p class="font-weight-bold h4">Thông tin khách hàng</p>
          <div class="d-flex justify-content-between">
            <p class="font-weight-bold">Họ và tên:</p>
            <p class="font-weight-bold">{{ contract.name }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p class="font-weight-bold">Số điện thoại:</p>
            <p class="font-weight-bold">{{ contract.phone }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p class="font-weight-bold">SĐT khác:</p>
            <p class="font-weight-bold">{{ contract.phone_other }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p class="font-weight-bold">Email:</p>
            <p class="font-weight-bold">{{ contract.email }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p class="font-weight-bold">Ngày sinh:</p>
            <p class="font-weight-bold">{{ contract.birthday | formatDate }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p class="font-weight-bold">Căn cước công dân:</p>
            <p class="font-weight-bold">{{ contract.cccd }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p class="font-weight-bold">Địa chỉ:</p>
            <p class="font-weight-bold">{{ contract.address }}</p>
          </div>
          <div v-if="!contract.is_older">
            <p class="font-weight-bold h4 mt-4">Thông tin người giám hộ</p>
            <div class="d-flex justify-content-between">
              <p class="font-weight-bold">Mối quan hệ:</p>
              <p class="font-weight-bold">
                {{ contract.parent.type ? typeFormatText[contract.parent.type] : "" }}
              </p>
            </div>
            <div class="d-flex justify-content-between">
              <p class="font-weight-bold">Họ và tên người giám hộ:</p>
              <p class="font-weight-bold">{{ contract.parent.name }}</p>
            </div>
            <div class="d-flex justify-content-between">
              <p class="font-weight-bold">Số điện thoại người giám hộ:</p>
              <p class="font-weight-bold">{{ contract.parent.phone }}</p>
            </div>
            <div class="d-flex justify-content-between">
              <p class="font-weight-bold">Số điện thoại người giám hộ khác:</p>
              <p class="font-weight-bold">{{ contract.parent.phone_other }}</p>
            </div>
          </div>
          <p class="font-weight-bold h4 mt-4">Thông tin đơn hàng</p>
          <p class="font-weight-bold h5">Danh sách khóa học</p>
          <div
            class="d-flex justify-content-between ml-2"
            v-for="(item, index) in contract.courses"
            :key="index"
          >
            <p class="font-weight-bold">
              <i class="el-icon-menu text-primary mr-2"></i>{{ item.name }}
            </p>
            <p class="font-weight-bold">{{ item.fee | formatVND }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p class="font-weight-bold">Tổng giá gốc:</p>
            <p class="font-weight-bold">{{ contract.total | formatVND }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p class="font-weight-bold">Tổng khuyến mại:</p>
            <p class="font-weight-bold text-success">
              {{ totalPromotions | formatVND }}
            </p>
          </div>
          <div v-if="isShowWarrantySummary">
            <hr />
            <p class="font-weight-bold h5">Gói dịch vụ bảo hành</p>
            <hr />
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span>
                <i class="el-icon-menu mr-2"></i>
                <span class="font-weight-bold">{{ contract.service.name }}</span>
              </span>
              <span class="font-weight-bold">{{ warrantyServiceAmount | formatVND }}</span>
            </div>
            <hr />
          </div>
          <div class="d-flex justify-content-between">
            <p class="font-weight-bold">Tổng thanh toán:</p>
            <p class="font-weight-bold text-danger">
              {{ finalTotalNeed | formatVND }}
            </p>
          </div>
          <p class="font-weight-bold h4 mt-4">Hình thức hoàn thành học phí</p>
          <hr />
          <div class="d-flex justify-content-between">
            <span class="badge badge-primary">
              {{
                contract.tuition_payment_id
                  ? tuitionPayment[contract.tuition_payment_id]
                  : "Chưa chọn hình thức thanh toán"
              }}
            </span>
          </div>
          <div class="mt-3" v-if="contract && contract.description">
            <p class="font-weight-bold h4">Quà tặng</p>
            <el-input
              disabled
              v-if="contract.description"
              v-model="contract.description"
              :rows="5"
              type="textarea"
              placeholder="Quà tặng"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="card-body border">
        <p class="font-weight-bold h4 text-center">Điều khoản chính sách</p>
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item
            :key="item.id"
            v-for="item in contract.policy ? contract.policy : policy"
            :title="item.name"
            :name="item.policy_catalog ? item.policy_catalog.id : item.id ?? ''"
          >
            <div class="policy-content table-ck ql-editor" v-html="item.content"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="card-body border mt-4">
        <div class="mt-2">
          <div class="box-instruct">
            <h4 style="font-weight: 600; color: black">Hướng dẫn thanh toán:</h4>
            <h5 v-if="paymentAmount">
              Cách thức thanh toán: {{ isOnePay ? "Thanh toán qua thẻ (OnePay)" : "Chuyển khoản" }} - Số tiền:
              <span> {{ paymentAmount.toLocaleString("vi-VN") }} </span>đ
            </h5>
            <div style="line-height: 2" v-if="showInstruct">
              <span>Nộp học phí trực tiếp tại hệ thống Trung tâm {{ centerName }}</span
              ><br />
              <span
                >Thời gian: từ 14h00 đến 21h00 các ngày từ thứ 2 tới thứ 7 hàng tuần (trừ
                ngày lễ, tết theo quy định Nhà nước).</span
              ><br />
              <span
                >Khi đến văn phòng giao dịch thuộc văn phòng {{ centerName }}, học viên
                sẽ được nhân viên hướng dẫn các bước thanh toán.</span
              >
            </div>
            <div v-if="isOnePay" style="line-height: 2">
              <h5 style="font-weight: 600; color: black" class="mb-2">HƯỚNG DẪN THANH TOÁN ONEPAY</h5>
              <span
                >Hình thức OnePay không hỗ trợ thanh toán bằng mã QR. Vui lòng hướng dẫn khách hàng thanh toán theo link OnePay trên phiếu đăng ký học tập.</span
              ><br />
              <span><strong>Bước 1.</strong> Nhận link thanh toán Onepay trên phiếu đăng ký học tập</span
              ><br />
              <span
                >Kiểm tra nội dung hóa đơn và chọn "I agreed with Terms and Conditions", chọn CHECK OUT TO PAY để thực hiện thanh toán</span
              ><br />
              <span><strong>Bước 2.</strong> Nhập thông tin thẻ</span><br />
              <span>Khách hàng điền thông tin thẻ và nhấn nút Process Payment để thực hiện thanh toán</span
              ><br />
              <span
                ><strong>Lưu ý:</strong> Nếu thẻ có tham gia chương trình xác thực 3D-Secure thì sau khi nhập thông tin thẻ. Ngân hàng sẽ yêu cầu nhập thêm mật khẩu</span
              >
            </div>
            <div v-else-if="showQr">
              <div style="line-height: 2">
                <span
                  >Bước 1: Chuyển khoản theo thông tin chi tiết {{ centerName }} cung cấp:
                </span><br>
                <span>Bạn có thể gửi mã QR này cho khách hàng:</span>

                <div style="line-height: 2">
                  <div class="qr-code d-flex">
                    <div>
                      <img style="width: 315px" :src="qrCode" alt="QR Code" />
                    </div>
                    <div class="mt-4">
                      <span>- Ngân hàng {{ paymentOption?.bank_name }}</span
                      ><br />
                      <span>- Chủ tài khoản: {{ paymentOption?.bank_account_name }} </span
                      ><br />
                      <span>- Số tài khoản: {{ paymentOption?.bank_account_number }}</span
                      ><br />
                      <span
                        >- Nội dung chuyển khoản: {{ prefix }}{{ paymentOption?.payment_code }} {{ contract.phone }}</span
                      ><br />

                      <div>
                        <el-checkbox v-model="checkedEditAccount"
                          >Khách hàng muốn thay đổi tài khoản thanh toán</el-checkbox
                        >
                      </div>
                      <div v-if="waitingAccept" class="flex items-center">
                        <i class="el-icon-loading"></i>
                        <span class="ml-2"
                          >Đang chờ xác nhận từ admin duyệt phiếu đăng ký trong khoảng 10
                          phút
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <span>Bước 2: Hoàn tất thông tin sau tin nhắn xác nhận chuyển tiền</span
                  ><br />
                  <span
                    >{{ centerName }} sẽ nhắn tin tới số điện thoại khách hàng cung cấp
                    trong nội dung chuyển khoản để xác nhận thông tin chuyển tiền muộn
                    nhất trong vòng 4h (theo giờ hành chính) sau khi nhận được tiền.
                    <span>Trường hợp không nhận được tin nhắn, bạn vui lòng báo khách hàng vui
                    lòng liên hệ qua {{ hotLine }} để được xử lý.</span>
                    </span
                  ><br />
                  <span
                    >{{ centerName }} không chịu trách nhiệm nếu trong quá trình chuyển
                    khoản sai thông tin. Trong một số tình huống cụ thể, khách hàng có thể
                    nhờ phía Ngân hàng thực hiện chuyển khoản hoặc Ngân hàng thụ hưởng của
                    {{ centerName }} để kiểm tra đối chứng cần thiết. Ngay khi nhận được
                    xác nhận từ Ngân hàng, {{ centerName }} sẽ tiến hành thủ tục tiếp theo
                    cho Khách hàng.</span
                  ><br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        title="Phiếu đăng ký thay đổi tài khoản thanh toán"
        :visible.sync="checkedEditAccount"
      >
        <hr />
        <ChangeAccount
          :is_show="checkedEditAccount"
          :payment_option="paymentOption"
          @changeWaitingAccept="waitingAccept = true"
          @changeQrCode="handleEmitChangeAccount"
          :contract="contract"
          @close="checkedEditAccount = false"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ecoach_collapse_hinh_thuc_hoan_thanh_hoc_phi from "@/views/pages/customer/components/EcoachPolicy/ecoach_collapse_hinh_thuc_hoan_thanh_hoc_phi";
import ecoach_collapse_chinh_sach_bao_mat from "@/views/pages/customer/components/EcoachPolicy/ecoach_collapse_chinh_sach_bao_mat";
import ecoach_collapse_dieu_khoan_dang_ky_hoc from "@/views/pages/customer/components/EcoachPolicy/ecoach_collapse_dieu_khoan_dang_ky_hoc";
import ecoach_collapse_hinh_thuc_thanh_toan from "@/views/pages/customer/components/EcoachPolicy/ecoach_collapse_hinh_thuc_thanh_toan";
import ecoach_collapse_chinh_sach_hoc_tap from "@/views/pages/customer/components/EcoachPolicy/ecoach_collapse_chinh_sach_hoc_tap";
import {
  tuitionPayment,
  typeFormatText,
} from "@/core/config/contract/contractOnlineOption";
import { ECOACH, IELTS, MENTER_ENGLISH_MASTERY, isWarrantyServiceCenter } from "@/core/config/center/centerOption";
import Ieltsmentor_collapse_chinh_sach_bao_mat from "@/views/pages/customer/components/IMPolicy/ieltsmentor_collapse_chinh_sach_bao_mat";
import Ieltsmentor_collapse_dieu_khoan_dang_ky_hoc from "@/views/pages/customer/components/IMPolicy/ieltsmentor_collapse_dieu_khoan_dang_ky_hoc";
import Ieltsmentor_collapse_hinh_thuc_thanh_toan from "@/views/pages/customer/components/IMPolicy/ieltsmentor_collapse_hinh_thuc_thanh_toan";
import Ieltsmentor_collapse_hinh_thuc_hoan_thanh_hoc_phi from "@/views/pages/customer/components/IMPolicy/ieltsmentor_collapse_hinh_thuc_hoan_thanh_hoc_phi";
import Ieltsmentor_collapse_chinh_sach_hoc_tap from "@/views/pages/customer/components/IMPolicy/ieltsmentor_collapse_chinh_sach_hoc_tap";
import ChangeAccount from "./ChangeAccountPayment.vue";
import {
  GET_RATIO_PAYMENT,
  GET_PAYMENT_OPTION_BY_CONTRACT_ID,
} from "@/core/services/store/contract/contractOnline.module";

export default {
  name: "CompletedStudyForm",
  components: {
    Ieltsmentor_collapse_chinh_sach_hoc_tap,
    Ieltsmentor_collapse_hinh_thuc_hoan_thanh_hoc_phi,
    Ieltsmentor_collapse_hinh_thuc_thanh_toan,
    Ieltsmentor_collapse_dieu_khoan_dang_ky_hoc,
    Ieltsmentor_collapse_chinh_sach_bao_mat,
    ecoach_collapse_chinh_sach_hoc_tap,
    ecoach_collapse_hinh_thuc_thanh_toan,
    ecoach_collapse_dieu_khoan_dang_ky_hoc,
    ecoach_collapse_chinh_sach_bao_mat,
    ecoach_collapse_hinh_thuc_hoan_thanh_hoc_phi,
    ChangeAccount,
  },
  props: {
    contract: {
      type: Object,
      default: () => {
        return null;
      },
    },
    policy: {
      default: null,
    },
  },
  data() {
    return {
      paymentOption: [],
      ECOACH: ECOACH,
      IELTS: IELTS,
      MENTER_ENGLISH_MASTERY: MENTER_ENGLISH_MASTERY,
      tuitionPayment: tuitionPayment,
      typeFormatText: typeFormatText,
      is_ecoach: false,
      activeName: 1,
      checkedEditAccount: false,
      qrCode: "",
      prefix: '',
      hotLine: '',
      centerName: "",
      showQr: false,
      showInstruct: false,
      paymentOptionId: "",
      paymentAmount: "",
      waitingAccept: "",
    };
  },
  watch: {
    waitingAccept(newVal) {
      if (newVal === true) {
        this.getTimeCountDown();
      }
    },
  },
  mounted() {
    this.handleShowMethodPayment();
    this.getTimeCountDown();
    if (this.contract.center_id === ECOACH) {
      this.is_ecoach = true;
    } else {
      this.is_ecoach = false;
    }
  },

  methods: {
    async handleShowMethodPayment() {
      this.paymentAmount =
        this.contract.payment_amount ||
        this.contract.payment_options?.display_amount ||
        this.contract.payment_options?.payment_amount;
      this.prefix = this.contract.center_id === 295 ? "EC" : "IE";

      switch (this.contract.center_id) {
        case 295:
            this.hotLine = 'tổng đài 1900 4782';
          break;

        case 530:
        case 516:
          this.hotLine = 'tổng đài 1900 4455';
          break;

        default:
          this.hotLine = '';
          break;
            }

      this.centerName = this.prefix == "EC" ? "ECoach" : "IELTS Mentor";
      this.paymentOption = this.contract?.payment_options;
      if (this.methodPaymentIds.includes(3)) {
        this.showQr = true;
      }
      if ([1, 2].some((id) => this.methodPaymentIds.includes(id))) {
        this.showInstruct = true;
      }

      if (this.paymentOption) {
        let timeAccept = this.paymentOption.time_accept;
        if (!timeAccept || new Date(timeAccept) < new Date()) {
          this.qrCode = this.buildQrCode(this.paymentOption);
          this.waitingAccept = false;
        } else {
          this.waitingAccept = true;
        }
      } else {

        if (this.methodPaymentIds.includes(3) && !this.isOnePay) {
          this.getPaymentOptionByContractId();
          await this.$store
            .dispatch(GET_RATIO_PAYMENT, {
              branch_id: this.contract.branch_id,
              contract_id: this.contract.id,
            })
            .then((data) => {
              if (!data.data) {
                this.$notify({
                  title: "Không tìm thấy phương thức thanh toán!",
                  message: "Thất bại!",
                  type: "error",
                });
              }
              this.paymentOption = data?.data;
              this.qrCode = this.buildQrCode(this.paymentOption);
            });
        }
      }
    },

    isOnePayBank(option = this.paymentOption) {
      const bankName = (option?.bank_name || "")
        .toString()
        .trim()
        .toUpperCase()
        .replace(/\s+/g, "");
      return bankName === "ONEPAY";
    },

    buildQrCode(option) {
      if (!option || this.isOnePayBank(option)) {
        return "";
      }
      const bank = (option.bank_name || "").toString().trim();
      const acc = (option.bank_account_number || "").toString().trim();
      const code = (option.payment_code || "").toString().trim();
      if (!bank || !acc || !code) {
        return "";
      }
      let url = `https://qr.sepay.vn/img?bank=${bank}&acc=${acc}&template=compact&des=${this.prefix}${code} ${this.contract.phone}`;
      if (this.paymentAmount > 0) {
        url += `&amount=${this.paymentAmount}`;
      }
      return url;
    },

    handleEmitChangeAccount(item) {
      this.paymentOption = item;
      this.qrCode = this.buildQrCode(item);
      this.waitingAccept = false;
      this.checkedEditAccount = false;
    },

    getTimeCountDown() {
      const key = `paymentStartTime_${this.contract.id}`;
      const savedStart = localStorage.getItem(key);
      if (savedStart) {
        this.startCountup(parseInt(savedStart), key);
      }
    },

    async getPaymentOptionByContractId() {
      await this.$store
        .dispatch(GET_PAYMENT_OPTION_BY_CONTRACT_ID, {
          contract_id: this.contract.id,
        })
        .then((data) => {
          this.contract.payment_options.id = data.data.id ?? "";
        });
    },

    startCountup(startTime, storageKey) {
      const interval = setInterval(() => {
        const now = Date.now();
        const elapsed = now - startTime;

        if (elapsed >= 10 * 60 * 1000) {
          localStorage.removeItem(storageKey);
          clearInterval(interval);
          location.reload();
          return;
        }
        const minutes = Math.floor(elapsed / 60000);
        const seconds = Math.floor((elapsed % 60000) / 1000);
        this.displayTime = `${String(minutes).padStart(2, "0")}:${String(
          seconds
        ).padStart(2, "0")}`;
      }, 1000);
    },
  },
  computed: {
    methodPaymentIds() {
      const raw = this.contract?.method_payment_id;
      if (Array.isArray(raw)) {
        return raw.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
      }
      if (raw == null || raw === "") {
        return [];
      }
      return String(raw)
        .split(",")
        .map((id) => Number(id))
        .filter((id) => !Number.isNaN(id));
    },
    isOnePay() {
      if (this.isOnePayBank()) {
        return true;
      }
      const paymentMethod = (this.paymentOption?.payment_method || "").toString();
      if (paymentMethod.includes("Thanh toán qua thẻ")) {
        return true;
      }
      return this.methodPaymentIds.includes(4);
    },
    isRegisterStudy() {
      return this.$route.name === 'register-study';
    },
    isShowWarrantySummary() {
      return isWarrantyServiceCenter(this.contract.center_id) && !!this.contract.service_id;
    },
    warrantyServiceAmount() {
      return Number(this.contract.service_total) || 0;
    },
    displayTotalPromotions() {
      if (!this.contract) return 0;
      const total = Number(this.contract.total) || 0;
      const totalAfterVoucher = Number(this.contract.total_after_voucher) || 0;
      const destroyFee = Number(this.contract.destroy_fee) || 0;
      const serviceTotal = Number(this.contract.service_total) || 0;
      return Math.max(0, total - totalAfterVoucher + destroyFee + serviceTotal);
    },
    finalTotalNeed() {
      if (this.contract && this.contract.total_need != null && Number(this.contract.total_need) > 0) {
        return Number(this.contract.total_need);
      }
      if (this.isRegisterStudy) {
        return Number(this.contract.total_need) || 0;
      } else {
        return this.contract.total_after_voucher;
      }
    },
    totalPromotions() {
      if (this.contract && this.contract.total_promotions != null && Number(this.contract.total_promotions) >= 0) {
        return Number(this.contract.total_promotions);
      }
      if (this.isRegisterStudy) {
        return Number(this.contract.total_promotions) || 0;
      } else {
        return this.displayTotalPromotions;
      }
    },
  },
};
</script>

<style scoped></style>
